import styled from 'styled-components';

export const StyledTabLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  align-items: flex-start;
  padding: 2rem;
`;

export const StyledCategoryList = styled.div`
  flex: 1 1 20rem;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledStatsSidebar = styled.div`
  flex: 0 0 26rem;
  max-width: 100%;
`;
